import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import MenuHorizontal from "../../layouts/MenuHorizontal";
import {
  Container,
  Grid,
  Icon,
  Divider,
  Button,
  Transition,
} from "semantic-ui-react";
import { find } from "../../../actions/competidor";
import { Rodape } from "../../layouts/Rodape";
import Competidor from "./Competidor";

class Competidores extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      errors: {},
    };
  }

  componentWillMount = async () => {
    await this.props.find();
    this.setState({ loading: false });
  };

  render() {
    const { competidores } = this.props;
    return (
      <div>
        <MenuHorizontal />
        <Container style={{ paddingTop: "10px" }}>
          <div style={{ textAlign: "center", marginBottom: "35px" }}>
            <Button
              className="ui-btn-1"
              as={Link}
              to={"/dashboard/competidores/cadastrar"}
            >
              <Icon name="plus" /> Adicionar Competidor
            </Button>
            <Transition>
              <div>
                <div className="ui-div-msg">
                  <br />
                </div>
                <Link to="/dashboard" size="small">
                  Voltar
                </Link>
              </div>
            </Transition>
          </div>
          <Divider horizontal>Competidores</Divider>
          <Grid columns={4} doubling stackable style={{ marginTop: "20px" }}>
            {!!competidores.length &&
              competidores.map((competidor) => (
                <Grid.Column key={competidor._id}>
                  <Competidor competidor={competidor} />
                </Grid.Column>
              ))}
          </Grid>
        </Container>
        <Rodape />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    competidores: state.competidor.competidores,
    quantidade: state.competidor.quantidade,
    error: state.competidor.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      find,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Competidores);
